import axios from '@/plugins/axios';

const DEFAULT_LOGO = require('@/assets/img/Gananms-logo.png');

export const state = () => ({
  organization: null,
});

export const mutations = {
  setOrganization(state, data) {
    state.organization = data;
  },
};

export const actions = {
  fetchOrganization({ commit }) {
    return axios
      .get('organizations/1')
      .then((res) => {
        commit('setOrganization', res.data);
        return res;
      })
      .catch((err) => Promise.reject(err));
  },
};

export const getters = {
  logoUrl(state) {
    return (state.organization && state.organization.image) || DEFAULT_LOGO;
  },
  brandName(state) {
    return (state.organization && state.organization.name) || 'Gnanams';
  },
  brandTagline(state) {
    const tagline =
      state.organization && state.organization.tagline;
    if (tagline != null && String(tagline).trim() !== '') {
      return String(tagline).trim();
    }
    return 'Hotel';
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
